import { GoogleOAuthProvider } from "@react-oauth/google";
import ThemeProvider from "../context/ThemeContext";
import AuthProvider  from "../context/AuthContext";
import SettingsProvider from "../context/SettingsContext";
import { ToastProvider } from "../components/ui/ModernToast";

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || "";

const AppProviders = ({ children }) => (
  <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
    <ThemeProvider>
      <AuthProvider>
        <SettingsProvider>
          <ToastProvider>
            {children}
          </ToastProvider>
        </SettingsProvider>
      </AuthProvider>
    </ThemeProvider>
  </GoogleOAuthProvider>
);

export default AppProviders;
